import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TimeClockLocationContainer from '../../containers/TimeClockLocation';
import FormSelect from "../form/FormSelect";

class TimeClockLocationSelect extends PureComponent {
	componentDidMount() {
		const { timeClockLocations, searchLocations } = this.props;
		if (_.isEmpty(timeClockLocations)) {
			searchLocations();
		}
	}

	render () {
		const { timeClockLocations } = this.props;
		if (_.isEmpty(timeClockLocations)) {
			return (<div>Fetching Locations...</div>);
		}

		let options = timeClockLocations.map((timeClockLocation) => {
			const { timeClockLocationId, display } = timeClockLocation;
			return {
				value: timeClockLocationId,
				display: display,
			}
		});
		options = _.sortBy(options, 'display');

		return (
			<FormSelect
				{...this.props}
				options={options}
			/>
		);
	}
}

TimeClockLocationSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	helpText : PropTypes.string,
	timeClockLocations : PropTypes.array,
};

TimeClockLocationSelect.defaultProps =  {
	label : 'Time Clock Location',
	timeClockLocations: [],
};

export default TimeClockLocationContainer(TimeClockLocationSelect);
